import { createContext, useContext, type ReactNode } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

interface NetworkStatusContextValue {
  isOnline: boolean;
}

const NetworkStatusContext = createContext<NetworkStatusContextValue>({ isOnline: true });

/**
 *
 * @param root0
 * @param root0.children
 */
export function NetworkStatusProvider({ children }: { children: ReactNode }) {
  const { isOnline } = useNetworkStatus();
  return (
    <NetworkStatusContext.Provider value={{ isOnline }}>{children}</NetworkStatusContext.Provider>
  );
}

/**
 *
 */
export function useNetworkStatusContext() {
  return useContext(NetworkStatusContext);
}
